{
  "_about": "The ONE list of driver handheld layouts and colour themes (driver handheld P1). The API validates against it (embedded in RoutingApp.Infrastructure) and the handheld's pickers are built from it (bundled by tools/build.mjs). Adding a layout or a theme is an entry here plus its words in tower/i18n (display.layout.<id> / display.theme.<id>). Ids are readable words; 'aliases' are older ids that are still read and rewritten to the id (the letter ids used while the concepts were being chosen, and the p4/p5/L4 placeholders).",
  "layouts": [
    { "id": "deck", "name": "Deck", "aliases": [] },
    { "id": "ledger", "name": "Ledger", "aliases": ["C"] },
    { "id": "flight", "name": "Flight deck", "aliases": ["A"] },
    { "id": "nextstop", "name": "Next stop first", "aliases": ["B"] },
    { "id": "grid", "name": "Glove Grid", "aliases": ["L4"] }
  ],
  "themes": [
    { "id": "ledger-light", "palette": "ledger", "tone": "light" },
    { "id": "ledger-dark", "palette": "ledger", "tone": "dark" },
    { "id": "flight-light", "palette": "flight", "tone": "light" },
    { "id": "flight-dark", "palette": "flight", "tone": "dark" },
    { "id": "navy-light", "palette": "navy", "tone": "light" },
    { "id": "navy-dark", "palette": "navy", "tone": "dark" },
    { "id": "iris-light", "palette": "iris", "tone": "light", "aliases": ["p4-light"] },
    { "id": "iris-dark", "palette": "iris", "tone": "dark", "aliases": ["p4-dark"] },
    { "id": "slate-light", "palette": "slate", "tone": "light", "aliases": ["p5-light"] },
    { "id": "slate-dark", "palette": "slate", "tone": "dark", "aliases": ["p5-dark"] }
  ],
  "modes": ["auto", "day", "night"],
  "defaults": { "layout": "deck", "dayTheme": "ledger-light", "nightTheme": "flight-dark", "themeMode": "auto" }
}
